import { Injectable } from '@angular/core';
import { SnackbarService } from '@reenstudio/app/shared/services/snackbar/snackbar.service';
import { environment } from '@reenstudio/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AbstractApiService } from './abstract-api.service';
import { NGXLogger } from 'ngx-logger';
import { WeatherModel } from '@reenstudio/app/core/models/api/weather/weather-api-model';

@Injectable({
  providedIn: 'root',
})
export class WeatherService extends AbstractApiService {
  private readonly endpoint = '/weather';

  constructor(
    private snackBar: SnackbarService,
    protected override http: HttpClient,
    protected override logger: NGXLogger
  ) {
    super(http, logger);
  }

  apiKey = environment.googleMapsApiKey;

  // getWeather(lat: number, lng: number) {
  //   return this.http.get(
  //     `@open-api/https://api.open-meteo.com/v1/dwd-icon?latitude=${lat}&longitude=${lng}&current=temperature_2m,is_day,precipitation,rain,showers,snowfall,weathercode,cloudcover&hourly=direct_radiation&timezone=Europe%2FBerlin&forecast_days=1`
  //   );
  // }

  getWeather(params: { from: string; to: string; cer?: number }) {
    return this.fetch<WeatherModel[]>(`${this.endpoint}`, params, false);
  }

  getForecast(lat: number, lng: number) {
    return this.http.get(
      `@open-api/https://api.open-meteo.com/v1/gfs?latitude=${lat}&longitude=${lng}&daily=weather_code,temperature_2m_max,temperature_2m_min,precipitation_probability_max&timezone=Europe%2FBerlin`
    );
  }

  //  NEW FORCAST
  // getForecast(params: { from: string; to: string; cer?: number }) {
  //   return this.fetch<WeatherModel[]>(`${this.endpoint}`, params, false);
  // }

  // getHourly(lat: number, lng: number) {
  //   return this.http.get(
  //     `@open-api/https://api.open-meteo.com/v1/gfs?latitude=${lat}&longitude=${lng}&hourly=temperature_2m,weather_code&timezone=Europe%2FBerlin&forecast_days=1`
  //   );
  // }

  getHourly(params: { from: string; to: string; cer?: number }) {
    return this.fetch<WeatherModel[]>(`${this.endpoint}`, params, false);
  }

  getLatLng(cityName: string) {
    return this.http.get(
      `@open-api/https://maps.googleapis.com/maps/api/geocode/json?address=${cityName}&key=${this.apiKey}`
    );
  }

  getCity(lat: number, lng: number) {
    return this.http.get(
      `@open-api/https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${this.apiKey}`
    );
  }
}
